<div class="grid-container padding-y-4">
    <div class="grid-row">
        <legend class="usa-legend usa-legend--large">GSA 3080 Admin</legend>
    </div>
    <div class="grid-row">
        For Domestic and International Shipments
    </div>
    <div class="grid-row grid-gap">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            To View, Reset, Modify or Delete a GSA 3080 Survey, enter either the Survey Number or Bill of Lading (BOL) Number and then select "Search."
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <fieldset class="usa-fieldset radio-buttons-inline">
                    <div *ngFor="let radiobutton of radioItems; let i = index" class="usa-radio define-background-checkbox define-{{i}}">
                        <input class="usa-radio__input" id="{{radiobutton}}" type="radio" (click)="model.option = radiobutton" [checked]="radiobutton === model.option">
                        <label class="usa-radio__label" for="{{radiobutton}}">{{radiobutton}}</label>
                    </div>
            </fieldset>

        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <input class="usa-input" id="survery-no" name="survey-no" type="text" [(ngModel)]="surveyNo">
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2 padding-top-1 modify-button">
            <button class="usa-button" [disabled]="(model.option === null || model.option === '' || model.option === undefined) ||
                      (surveyNo === null || surveyNo === '' || surveyNo === undefined)" (click)="modifySurvey()">Search
      </button>
        </div>
    </div>
    <div class="grid-row padding-y-4">
        <p>OR</p>
    </div>
    <div class="grid-row">
        Searching using employee last name
    </div>
    <div class="grid-row">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            To search for a GSA 3080 Survey by an employee's last name, enter the last name and then select "Search."
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <input type="text" class="usa-input" id="last-name" [(ngModel)]="lastNameEmployee">
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3 padding-top-1 modify-button">
            <button type="button" class="usa-button" [disabled]="lastNameEmployee === null || lastNameEmployee === '' || lastNameEmployee === undefined" (click)="seachByEmpLastName()">Search
      </button>
        </div>
    </div>
</div>